import { BrowserRouter, Route, Routes } from "react-router-dom";
import store from './reducer/store/store.js'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom/client';
import './styles/main.scss'
import LoginForm from "./pages/Home/Register";
import InsightForm from "./pages/Insight";
import AIForm from "./pages/AI";
import PowerBIForm from "./pages/PowerBI";
import HomePage from "./pages/Home";
import Admin from "./pages/Home/Admin";
import Register from "./pages/Home/Register";
import Missing from "./pages/Home/Missing";
import PersistLogin from "./pages/Home/PersistLogin";
import TestForm from "./pages/Test";
import FundInvestment from "./pages/FundInvestment";
import GlobalMarket from "./components/GlobalMarket";
import ThailandMarket from "./components/ThailandMarket";
import MainPage from "./pages/Homepage";
import Login from "./Login"
import GlobalFeedProduction from "./components/GlobalMarket/GlobalFeedProduction.jsx";
import CpWorldWide from "./components/GlobalMarket/CpWorldWide.jsx";
import CpfFeedProduction from "./components/GlobalMarket/CpfFeedProduction.jsx";
import ShareMarket from "./components/ThailandMarket/ShareMarket.jsx";
import QuantityAnimal from "./components/ThailandMarket/QuantityAnimal.jsx";
import SaleAnimal from "./components/ThailandMarket/SaleAnimal.jsx";
import DemandAnimal from "./components/ThailandMarket/DemandAnimal.jsx";
import Performance from "./components/Performance/index.js";
import WorkProcess from "./components/Performance/WorkProcess.jsx";
import TrendingPrice from "./pages/TrendingPrice/index.js";
import KPIs from "./components/Performance/KPIs.jsx";
import Competitor from "./components/Competitor/index.js";

const ROLES = {
  'User': 2001,
  'Editor': 1984,
  'Admin': 5150
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route element={<PersistLogin />}>
          <Route path="/home" element={<MainPage />} />
          <Route path="/insight" element={<InsightForm />} />
          <Route path="/AI" element={<AIForm />} />
          <Route path="/fund_investment" element={<FundInvestment />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/test" element={<TestForm />} />
          <Route path="/global-market/global-feed-production" element={<GlobalMarket />} />
          <Route path="/global-market/global-feed-production" element={<GlobalFeedProduction />} />
          <Route path="/global-market/cp-world-wide" element={<CpWorldWide />} />
          <Route path="/global-market/cpf-feed-production" element={<CpfFeedProduction />} />
          <Route path="/thailand-market/share-market" element={<ShareMarket />} />
          <Route path="/thailand-market/quantity-animal" element={<QuantityAnimal />} />
          <Route path="/thailand-market/sale-animal" element={<SaleAnimal />} />
          <Route path="/thailand-market/demand-animal" element={<DemandAnimal />} />
          <Route path="/thailand-market/thailand-market/quantity-animal" element={<ThailandMarket />} />
          <Route path="/power-bi" element={<PowerBIForm />} />
          <Route path="/performance" element={<Performance />} />
          <Route path="/performance/progress" element={<WorkProcess />} />
          <Route path="/performance/KPIs" element={<KPIs />} />
          <Route path="/material" element={<TrendingPrice />} />
          <Route path="/competitor" element={<Competitor />} />
        </Route>
        <Route path="*" element={<Missing />} />
      </Routes>
    </BrowserRouter>,
  </Provider>
);